import { createContext, type FC, useContext } from 'react';
import { useDisclosure } from '@chakra-ui/react';

interface ShoppingCartToggleContextValue {
  isOpen: boolean,
  onOpen: () => void,
  onClose: () => void,
  onToggle: () => void,
}

const ShoppingCartToggleContext = createContext<ShoppingCartToggleContextValue|null>(null);

export interface ShoppingCartToggleProviderProps {
}

export const ShoppingCartToggleProvider: FC<ShoppingCartToggleProviderProps> = ({
  ...props
}) => {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  return (
    <ShoppingCartToggleContext.Provider
      value={{
        isOpen,
        onOpen,
        onClose,
        onToggle,
      }}
      {...props}
    />
  );
};

export function useShoppingCartToggle() {
  const { isOpen, onOpen, onClose, onToggle } = useContext(ShoppingCartToggleContext) as Required<ShoppingCartToggleContextValue>;

  return {
    isOpen,
    onOpen,
    onClose,
    onToggle,
  };
}
